
import React from 'react';

import { motion } from 'framer-motion';

import {
  arabicImage,
  englishImage
} from '../../assets/Images';

import { useStateContext } from "../../context/ContextProvider";

function ToggleLanguages() {

  const {
    currentDir,
    setDir,
  } = useStateContext();

  const isArabic = currentDir === "rtl";

  const themLangHandeler = () => {

    if (isArabic) {

      setDir('ltr');

    } else {

      setDir('rtl');

    }

  };

  return (

    <motion.button
      whileTap={{ scale: 0.92 }}
      whileHover={{ y: -2 }}
      onClick={themLangHandeler}
      className="
     
      relative
      w-[46px]
      h-[46px]
      rounded-xl
      overflow-hidden
      border border-white/10
      bg-white/5 dark:bg-white/[0.03]
      backdrop-blur-md
      shadow-[0_4px_20px_rgba(0,0,0,0.10)]
      flex items-center justify-center
      transition-all duration-500
      group
      hover:bg-white/10
    "
  >

      {/* Glow */}
      <div
        className="
          absolute inset-0
          bg-gradient-to-br
          from-color-1/20
          via-transparent
          to-color-3/20
          opacity-0
          group-hover:opacity-100
          transition-opacity duration-500
        "
      />

      {/* Animated Background */}
      <motion.div
        animate={{
          rotate: isArabic ? 180 : 0,
          scale: isArabic ? 1.15 : 1,
        }}
        transition={{
          duration: 0.6,
          type: "spring",
        }}
        className="
          absolute
          w-16
          h-16
          rounded-full
          bg-gradient-to-br
          from-color-1/10
          to-color-3/10
          blur-2xl
        "
      />

      {/* Flag */}
      <motion.div
        key={currentDir}
        initial={{
          rotate: -180,
          opacity: 0,
          scale: 0.4,
        }}
        animate={{
          rotate: 0,
          opacity: 1,
          scale: 1,
        }}
        transition={{
          duration: 0.5,
          type: "spring",
        }}
        className="
          relative
          z-10
          w-[42px]
          h-[42px]
          rounded-xl
          overflow-hidden
          border border-white/20
          shadow-lg
        "
      >

        <img
          src={isArabic ? arabicImage : englishImage}
          alt={isArabic ? "Arabic" : "English"}
          className="
            w-full
            h-full
            object-cover
          "
        />

      </motion.div>

      {/* Floating Dot */}
      <motion.div
        animate={{
          y: [0, -3, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
        }}
        className="
          absolute
          top-2
          right-2
          w-2
          h-2
          rounded-full
          bg-color-1
          shadow-lg
        "
      />

    </motion.button>
  );
}

export default ToggleLanguages;

